export const downloadFile = (uri: string, fileName: string): void => {
  const a = document.createElement('a');
  a.href = uri;
  a.setAttribute('download', fileName);
  a.setAttribute('target', '_blank');
  a.click();
};
